import React, { useEffect } from 'react'
import { Modal } from 'antd'
import Loader from '../../../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetCustomerTicketsAttachmentsQuery } from '../../../redux/apis/customersManagement/tickets/customerTicketsApiSlice'

const ViewTicketMedia = ({ open, setOpen, record }) => {
  const { data, isLoading, error } = useGetCustomerTicketsAttachmentsQuery(record?.id)

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])
  console.log(data)

  return (
    <Modal
      className='customModal'
      open={open}
      title={`Ticket Attachments`}
      onCancel={() => setOpen(false)}
      footer={false}
    >
      <Loader isLoading={isLoading} />
      {data?.data?.results?.length > 0 ? <></> : <p className='text-black'>No attachments found</p>}
    </Modal>
  )
}

export default ViewTicketMedia
